import {useDevice, useIsInViewport} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {useEffect, useRef} from 'react';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';
import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';
import {ImagePreviewWithZoom} from './ImagePreviewWithZoom';

interface DocumentPreviewSlideshowItemProps {
  documentPage: DocumentPreviewPage;
  documentPreview: UseDocumentPreviewReturnType;
  onSlideshowItemInView: VoidFunction;
}

const slideshowItemWrapperVariants = cva('h-full w-full rounded-[var(--radius-medium)] py-4');

export function DocumentPreviewSlideshowItem(props: DocumentPreviewSlideshowItemProps) {
  const device = useDevice();

  const boxRef = useRef<HTMLDivElement>(null);

  const isInView = useIsInViewport(boxRef, THRESHOLD);

  /**
   * @description
   * Whenever an image item is inView, we trigger a callback to level up,
   * which sets the pointer to this element for comparison.
   * If the pointer is not equal to the activeIndex from controls,
   * then scrollIntoView is triggered to this element
   */
  useEffect(
    function notifySlideshowItemInView() {
      if (isInView && device !== 'mobile' && device !== 'tablet') {
        props.onSlideshowItemInView();
      }
    },
    [device, isInView, props]
  );

  return (
    <div ref={boxRef} className={cn(slideshowItemWrapperVariants())}>
      <ImagePreviewWithZoom
        documentPage={props.documentPage}
        documentPreview={props.documentPreview}
      />
    </div>
  );
}

const THRESHOLD = 0.85;
